var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path10, _path11, _path12, _path13, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 60,
    viewBox: "0 0 48 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02508 8.84657C10.8537 7.02493 13.4638 5.94536 18.3347 3.69873L23.5069 6.42259L29.8917 3.84867L41.2756 7.99692C46.8684 10.8207 45.1856 22.9406 46.4478 34.5108C47.1811 41.233 46.5201 45.7763 45.7054 55.1521L45.4084 60.4249C43.2817 58.9054 42.0301 58.9543 39.766 59.5253C41.028 52.8031 40.2008 48.8442 39.073 41.8327C38.8883 34.9501 38.8077 31.0779 37.5635 24.8149C35.5335 32.9345 35.2828 37.6844 35.7321 46.3558C32.9603 47.0555 28.6316 47.2596 23.5564 47.2804C20.9067 47.4539 18.0463 47.2155 10.564 46.2059C11.2073 38.0093 14.1028 34.4858 11.2251 25.6145C10.6075 29.2899 9.74721 31.4871 8.93055 36.7099C8.70782 45.0064 7.62604 46.6263 6.62903 53.9026C7.00046 55.9746 7.49425 57.3602 8.11396 59.4253C7.42095 58.8006 2.74368 58.9755 1.9766 60.4249L1.4074 54.7523C0.523969 47.5667 1.21822 41.0769 2.15062 32.3608L2.17458 32.1368C3.95639 25.5895 3.8574 13.0198 7.02508 8.84657Z",
    fill: "white",
    stroke: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.2614 53.2552C43.519 53.2345 41.2521 51.0611 41.0938 50.7812L41.2422 51.2561L41.9104 51.8808L42.9993 52.9803L41.5887 52.8304L43.618 53.2552L45.6968 53.705L44.2614 53.2552Z",
    fill: "black",
    fillOpacity: 0.45,
    stroke: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.10805 47.481C3.73156 47.7826 4.88995 48.6718 4.9641 48.9054C4.12749 48.3173 3.73436 48.0957 3.28128 48.0557C2.83448 48.2004 2.26477 48.8152 2.14164 48.9903C2.12269 49.028 2.11416 49.0437 2.11815 49.0303C2.1204 49.0228 2.12846 49.009 2.14164 48.9903C2.25107 48.7725 2.70804 47.8191 3.10805 47.481Z",
    fill: "black",
    fillOpacity: 0.45,
    stroke: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.1044 37.0854C3.1289 37.1198 2.56525 37.5472 2.41147 37.6352C2.59285 37.4408 2.73626 37.3469 2.73318 37.0854C2.58792 36.9676 2.51564 37.0362 2.38672 37.1604C2.54443 36.8762 2.635 36.7208 2.98066 36.7356C4.65428 37.115 5.56488 37.4107 7.11348 38.135C5.83212 37.7488 3.03705 36.991 3.1044 37.0854Z",
    fill: "black",
    fillOpacity: 0.45,
    stroke: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.713 4.87358L23.8514 5.37337L24.1483 5.69824L22.6882 7.29757L18.8276 5.72323L19.1246 2.89941L22.713 4.87358Z",
    fill: "white",
    stroke: "#757575"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0345 4.92089C20.9722 3.46704 19.0749 1.72224 19.2234 0.722656C18.7786 2.16835 18.5562 2.99322 17.9365 4.34613C18.2055 5.50557 18.5457 6.32959 19.4214 8.04458C20.6385 6.27054 21.417 5.55611 23.0345 4.92089Z",
    fill: "white",
    stroke: "#757575"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6921 7.37321C22.4516 6.28798 22.7498 5.73676 24.5729 4.92424L29.6709 3.125L28.7552 5.37405C26.4452 6.7906 25.0218 7.4309 22.6921 7.37321Z",
    fill: "white",
    stroke: "#757575"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2309 8.02184C26.2523 5.74205 25.313 4.8143 24.5188 4.97312C26.7708 3.19887 29.3693 2.27425 28.8991 0.5C29.4406 1.92082 29.713 2.76909 30.087 4.47333C29.6192 5.87208 29.1222 6.64447 28.2309 8.02184Z",
    fill: "white",
    stroke: "#757575"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7865 47.355C22.0194 35.1101 23.4052 25.2143 22.6133 7.24683",
    stroke: "#757575"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87413 54.1758C4.53354 53.5112 3.30877 53.5357 1.42969 54.9505C1.60292 56.7747 1.96719 60.5423 1.97413 60.4982C2.13043 59.5041 6.15645 58.574 8.1115 59.4236C7.53797 57.4258 7.24142 56.3053 6.87413 54.1758Z",
    fill: "white",
    stroke: "#757575"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9675 55.1273C42.2187 53.6515 43.4758 53.5871 45.6842 54.9774L45.412 60.4501C43.481 59.1061 42.2509 58.7888 39.6953 59.5504C39.921 57.995 39.9862 56.9898 39.9675 55.1273Z",
    fill: "white",
    stroke: "#757575"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.75,
    cx: 23.7012,
    cy: 6.39648,
    rx: 0.346464,
    ry: 0.349853,
    fill: "black",
    fillOpacity: 0.6,
    stroke: "#757575"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.75,
    cx: 24.0293,
    cy: 11.3457,
    rx: 0.346464,
    ry: 0.349853,
    fill: "black",
    fillOpacity: 0.6,
    stroke: "#757575"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.75,
    cx: 24.076,
    cy: 17.5413,
    rx: 0.346464,
    ry: 0.349853,
    fill: "black",
    fillOpacity: 0.6,
    stroke: "#757575"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.75,
    cx: 24.2246,
    cy: 24.9395,
    rx: 0.346464,
    ry: 0.349853,
    fill: "black",
    fillOpacity: 0.6,
    stroke: "#757575"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.75,
    cx: 24.4239,
    cy: 32.2869,
    rx: 0.346464,
    ry: 0.349853,
    fill: "black",
    fillOpacity: 0.6,
    stroke: "#757575"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.75,
    cx: 24.2246,
    cy: 39.7842,
    rx: 0.346464,
    ry: 0.349853,
    fill: "black",
    fillOpacity: 0.6,
    stroke: "#757575"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M42.7107 34.4355C41.9765 35.2519 40.4537 36.9645 40.236 37.2843C40.1301 37.4981 39.9463 37.8896 39.8423 38.1692C39.7911 38.3845 39.7587 38.5049 39.7658 38.4338C39.7715 38.3764 39.8004 38.2819 39.8423 38.1692C39.9353 37.7785 40.0907 37.075 40.1865 36.6346L42.2653 34.2606L39.3203 33.4609L43.9233 34.1107L42.7107 34.4355Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#757575"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.1685 20.4919C39.0758 21.4365 38.2808 24.2306 38.0796 24.8901C38.3214 23.0314 38.3946 22.0262 38.0796 20.4919C37.7305 19.8004 37.599 19.3949 37.4609 18.6427L37.4693 18.6503C37.7872 18.9391 37.968 19.1034 38.5746 19.0925C39.8552 16.4166 40.2693 14.8403 40.9751 12.0205C40.4283 14.7863 40.1373 16.3375 39.1685 19.0925C40.0956 18.463 40.612 18.0025 41.5195 16.8685C40.6615 18.4282 40.1371 19.1996 39.1685 20.4919Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#757575"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.04672 34.7372C7.59699 35.1262 8.19688 35.4931 8.95228 35.7118L8.68006 35.5119L8.40783 35.312L8.03662 34.8622C8.3341 34.7199 8.59459 34.7348 8.95228 34.7372C8.34374 34.5696 7.92865 34.5837 7.21995 34.5623C5.62792 33.846 4.86905 33.2189 3.43359 32.2383C4.73341 33.3533 5.48161 33.9534 7.04672 34.7372Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#757575"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.8142 22.4908C11.0723 23.0793 11.3742 24.797 11.2844 25.1897L11.3587 25.4146C11.4541 24.2729 11.4196 23.6327 11.2844 22.4908L11.1112 22.116L10.641 20.7916C10.262 19.6287 10.0652 18.864 9.72534 17.418C9.89032 18.2593 10.1213 19.5921 10.2203 19.9919C10.3062 20.339 10.4925 21.0165 10.7895 21.991C9.95947 21.0602 9.46543 20.6185 8.71069 19.5421C9.18513 20.3833 9.47546 20.877 10.8142 22.4908Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#757575"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_4376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.74964 24.987L10.1049 24.6283L10.4602 24.987L11.1025 25.6356L11.4506 25.9871L11.1028 26.339L9.4027 28.0587H13.7491H14.2491V28.5587V29.4787V29.9787H13.7491H9.40572L11.1067 31.6933L11.4558 32.0451L11.107 32.3972L10.4602 33.0504L10.1049 33.4091L9.74964 33.0504L6.10542 29.3705L5.757 29.0187L6.10542 28.6669L9.74964 24.987Z",
    fill: "#757575",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_625_4376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8802 33.0506L36.525 33.4093L36.1697 33.0506L35.5274 32.402L35.1793 32.0505L35.5271 31.6986L37.2272 29.9789H32.8808H32.3808V29.4789V28.5589V28.0589H32.8808H37.2242L35.5232 26.3443L35.1741 25.9925L35.5229 25.6404L36.1697 24.9872L36.525 24.6285L36.8802 24.9872L40.5245 28.667L40.8729 29.0189L40.5245 29.3707L36.8802 33.0506Z",
    fill: "#757575",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_4376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.0396,
    height: 10.9326,
    fill: "white",
    transform: "matrix(0 1 1 0 4.63867 23.499)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_625_4376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.0396,
    height: 10.9326,
    fill: "white",
    transform: "matrix(0 -1 -1 0 41.9912 34.5386)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegular);
export default __webpack_public_path__ + "static/media/regular.3092aad7fdb743d5cf9e64aa8f313a32.svg";
export { ForwardRef as ReactComponent };